import z from 'zod';
export const E164PhoneSchema = z.string().regex(/^\+[1-9]\d{10,15}$/, "Phone must follow E-164 format, +19876543210"); //switch to use google library